import { Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import React from "react";
import { translationService } from "../../services/translation/TranslationService";
import { CountryField, AddressField, AddressNumberField, ZipField, VatField, CityField, StateField } from "./AddressFields";

export default observer((props: {values: any, edit?: boolean, setFieldValue(field: string, value: string): void}) => {
    const {values, edit, setFieldValue} = {...props};
    
    console.log(values)
    return (
        <Grid container columnSpacing={10}>
            <Grid item xs={12} lg={12} sm={12} sx={{fontWeight: "bold"}}>{translationService.translate("account.address")}</Grid>
            <Grid item xs={6} lg={4} sm={4}>
                <CountryField value={values.country} readonly={!edit} setFieldValue={setFieldValue}/>
                <AddressField value={values.address} readonly={!edit} setFieldValue={setFieldValue}/>
            </Grid>
            <Grid item xs={6} lg={4} sm={4}>
                <AddressNumberField value={values.addressNumber}  readonly={!edit} setFieldValue={setFieldValue}/>
                <ZipField value={values.zip} readonly={!edit} setFieldValue={setFieldValue}/>
                <VatField value={values.vat} readonly={!edit} setFieldValue={setFieldValue}/>
            </Grid>
            <Grid item xs={6} lg={4} sm={4}>
                <CityField value={values.city} readonly={!edit} setFieldValue={setFieldValue}/>
                <StateField value={values.state} readonly={!edit} setFieldValue={setFieldValue}/>
            </Grid>
        </Grid>
    )
})